export default class CustomerNote {
  constructor (customerId, type) {
    this.actions = {
      create: 'createCustomerNote',
      update: 'updateCustomerNote',
      remove: 'deleteCustomerNote'
    }

    this.requestData = { customerId, type }
    this.name = 'note'
  }

  isNew (data) {
    return data.id === null || data.id === undefined
  }

  static empty () {
    return { id: null, text: '', isPrivate: false }
  }

  static parse (data) {
    return {
      id: data.id,
      text: data.text,
      isPrivate: data.isPrivate || false
    }
  }

  static parseResponseData (response) {
    let note = response.notes

    response.notes = (note && note.data && note.data.length > 0)
      ? note.data.map(CustomerNote.parse)
      : [CustomerNote.empty()]

    return response
  }
}
